export default __webpack_public_path__ + "static/Rocket_Propelled_Grenade-9a4424f2089adff6beb7acfed4502c3c.png";